export const API_URL = "https://vaaradhi.agrani.tech";
// export const Emandi_URL="http://65.2.40.145"
